import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";
import LoaderPage from "./Loader";
import Footer from "../Fotter";
import { AiOutlineArrowLeft } from "react-icons/ai";

const BlogDetails = () => {
    const { title } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        const getBlog = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `${endPoint.GetBlogById}/${title}`
                );
                setBlog(response?.data);
            } catch (error) {
                console.error("Error fetching blog:", error);
            } finally {
                setLoading(false);
            }
        };

        getBlog();
    }, [title]);

    if (loading) {
        return <LoaderPage />;
    }

    if (!blog) {
        return (
            <div className="text-center py-10 text-gray-600">
                Blog not found.
            </div>
        );
    }

    const isVideo =
        blog.media && blog.media.match(/\.(mp4|webm|ogg)$/i);

    return (
        <>
            <div className="max-w-5xl mx-auto px-4 py-8">
                <div className="mx-auto flex items-center w-[100%] mt-0 sm:mt-2 justify-between mb-5">
                    <button
                        onClick={() => navigate(-1)}
                        className="mr-2 bg-gray-200 px-2 py-2 rounded-full flex items-center"
                    >
                        <AiOutlineArrowLeft className="text-lg mr-1" />
                    </button>
                    <h1 className="sm:text-4xl text-xl font-semibold text-center text-black">
                        {blog?.title}
                    </h1>
                    <h1></h1>
                </div>

                {isVideo ? (
                    <video
                        src={blog.media}
                        controls
                        className="w-full h-64 md:h-96 object-cover rounded-lg mb-6"
                    />
                ) : (
                    <img
                        src={blog.media || "https://via.placeholder.com/800x400"}
                        alt={blog.title}
                        className="w-full h-64 md:h-96 object-cover rounded-lg mb-6"
                    />
                )}


                <div
                    className="prose prose-lg max-w-none text-gray-700 leading-relaxed"
                    dangerouslySetInnerHTML={{
                        __html: blog.content.replaceAll(
                            "<img",
                            '<img style="max-width:100%; height:auto; margin:15px 0; border-radius:8px;"'
                        ),
                    }}
                />
            </div >
            <Footer className="fixed" />
        </>
    );
};

export default BlogDetails;
